module.exports = __webpack_public_path__ + "static/img/9.f97906f7.jpg";